import {Observable} from "rxjs";

export interface IIdentityService
{
	getUserIdentityTokenObs(): Observable<string>;  // return (e.g. from msalService) user identification token
}